<template>
  <div class="expose-check">
    <div class="el-input-group el-input-group--append el-input-group--prepend options-container">
      <el-select
        v-close-on-zoom
        class="is-current-select"
        :value="state.isCurrent"
        :disabled="readonly"
        @input="isCurrent => updateCurrent(isCurrent)"
      >
        <el-option :value="false" label="Was ever" />
        <el-option :value="true" label="Is currently" />
      </el-select>
      <el-select
        id="expose-select"
        v-close-on-zoom
        :value="state.clothing"
        placeholder="any clothing"
        class="expose-select"
        :disabled="readonly"
        multiple
        @input="updateClothing"
      >
        <el-option
          v-for="clothing in filteredClothing"
          :key="clothing.key"
          :label="clothing.label.en"
          :value="clothing.key"
        />
      </el-select>
      <help-tooltip v-if="clothingWarnings" :show-space="false" type="warning">
        <span>{{ clothingWarnings.message }}</span>
      </help-tooltip>
      <div class="el-input-group__prepend el-input-group__append">was</div>
      <el-select
        v-close-on-zoom
        :value="state.category"
        :disabled="readonly"
        class="category-select"
        @input="updateCategory"
      >
        <el-option
          v-for="category in categories"
          :key="category.key"
          :label="category.label.en"
          :value="category.key"
        />
      </el-select>
    </div>
  </div>
</template>

<script>
import get from 'lodash/get';

import clothing from '~lib/common/config/clothing';
import HelpTooltip from '../../common/components/HelpTooltip';
import checkMixins from './mixins/CheckMixins';

export default {
  name: 'expose-check',
  components: {
    HelpTooltip,
  },
  mixins: [ checkMixins ],
  props: [
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
  ],
  data() {
    return {
      wasEverCategorires: [
        { key: 'REPLACED', label: { en: 'Replaced' }},
        { key: 'REMOVED', label: { en: 'Removed' }},
      ],
      isCurrentCategories: [
        { key: 'REPLACED', label: { en: 'On' }},
        { key: 'REMOVED', label: { en: 'Off' }},
      ],
      state: {
        isCurrent: false,
        category: 'REMOVED',
        clothing: [],
      },
    };
  },
  computed: {
    patientClothing() {
      return get(this.emitter.caseConf, 'outfit.clothingType');
    },
    hasUpperUnderwear() {
      return get(this.emitter.caseConf._avatar, 'avatarOptions.upperUnderwear');
    },
    filteredClothing() {
      return clothing
        .filter(item => {
          if (this.state.clothing.includes(item.key)) {
            return true; // have to display, because user has selected it
          }
          if (item.key === 'UPPER_UNDERWEAR') {
            return this.hasUpperUnderwear;
          }
          if (item.outfitRestrictions) {
            return item.outfitRestrictions.includes(this.patientClothing);
          }
          return true;
        });
    },
    categories() {
      return this.state.isCurrent ? this.isCurrentCategories : this.wasEverCategorires;
    },
    clothingWarnings() {
      return this.warnings.find(error => error.metadata.errorId.startsWith('clothing'));
    },
  },
  mounted() {
    const data = this.getData(this.ikey);
    this.state.isCurrent = get(data, 'isCurrent') || false;
    this.state.category = get(data, 'category') || 'REMOVED';
    const values = get(data, 'value') || [];
    this.state.clothing = this.valuesToClothing(values);
    this.update();
  },
  methods: {
    valuesToClothing(values) {
      return values.map(value => value.substring(0, value.lastIndexOf('_')));
    },
    clothingToValues(clothing) {
      return clothing.map(cloth => cloth + '_' + this.state.category);
    },
    updateCurrent(value) {
      this.state.isCurrent = value;
      this.update();
    },
    updateClothing(values) {
      this.state.clothing = values;
      this.update();
    },
    updateCategory(value) {
      this.state.category = value;
      this.update();
    },
    update() {
      this.putData(this.ikey, {
        type: 'EXPOSED',
        operator: 'EQUAL',
        isCurrent: this.state.isCurrent,
        category: this.state.category,
        value: this.clothingToValues(this.state.clothing),
      });
      this.emitter.trigger('process', this.control);
    },
  },
};
</script>

<style scoped>

.options-container {
  background: white;
}

.is-current-select {
  max-width: 160px;
}

.expose-select {
  min-width: 400px;
}

.category-select {
  max-width: 160px;
}
</style>
